import React, { useCallback, useContext, useEffect, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  EnrollmentStepWrapper,
  EnrollmentStepFooter,
  EnrollmentFormRow,
  EnrollmentFormCol,
  CreditCheckSection,
  InputWithMask,
  InputMaskToggle,
  InputWithIcon,
  EnrollmentTitle,
} from "../../styles/Enrollment.styled";
import { Button } from "../../styles/Button.styled";
import { Form, Dropdown, Spinner } from "react-bootstrap";
import { CheckboxItem } from "../../CheckboxItem";
import {
  SMS_INFORMATIONAL_CONSENT_FIELD,
  SMS_MARKETING_CONSENT_FIELD,
  SmsConsentAgreements,
} from "../../SmsConsentAgreements";
import { FormError } from "../../FormError";
import { confirmEnrollment, saveEnrollment, getEnrollmentRecord } from "../../../fetch/enrollment";
// import { toast } from 'react-toastify'
import moment, { Moment } from "moment";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import { LoadingRow } from "../../LoadingRow";
import { EnrollmentContext } from "./enrollment";
import {
  CONSTELLATION_UTIL_MAPPING,
  REFERER_URL,
} from "../../../config";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { FormLoading } from "../../FormLoading";
import { Address, EnrollmentFields } from "../../../types";
import { RadioBox } from "./RadioBox";
import { ValidateAddress } from "./validate_address";
import { EnrollmentStepService } from "./StepService";
import { getRegistrationErrorMessage, pushEnrollmentOrderComplete, pushEnrollmentEventToDataLayer, hasProvidedEnrollmentEmail, hasProvidedEnrollmentPhone } from "../../data";
import { scrollToFirstFormError } from "../../../utils/formUtils";
import { getUtmParams } from "../../../utils/utmParams";
import { preProcessFile } from "typescript";
import { usePlanContext } from "../../consteNew/context/planContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../../config";
import { FooterAwardImage } from "../../consteNew/styles/components";

enum RegistrationCheckStatus {
  Passed = "70.E01",
  RecaptchaRequired = "70.E02",
  RegistrationBlocked = "70.E03",
}

interface ServiceTypeOption {
  label: string;
  value: string;
  desc: string;
}
interface Props {
  show: boolean;
  handleBack: Function;
  handleContinue: Function;
  enrollmentId: string;
  dynamicFields: any;
  product: string;
  sign: string;
  specialPro: {
    ssn: any;
    date_of_birth: any;
  };
  handleEnrollId: Function;
  handleSSN: Function;
  handleSetName: Function;
  handleSetEmail: Function;
  handlePayment: Function;
}

interface StatesOption {
  name: string;
  abbr: string;
}

const dynamicFields: any = {
  ext_input: {
    date_of_birth: {
      type: "date",
      label: "Date of Birth",
    },
    premise_type: {
      type: "select",
      label: "Premise Type",
      value: [
        {
          label: "House",
          value: "House",
          desc: "House",
        },
        {
          label: "Apartment",
          value: "Apartment",
          desc: "Apartment",
        },
      ],
    },
  },
  credit_check: {
    ssn: {
      type: "text",
      label: "SSN",
    },
  },
};
export const EnrollmentStepInfo: React.FC<Props> = ({
  show,
  handleBack,
  handleContinue,
  product,
  enrollmentId: propEnrollmentId,
  sign: propSign,
  // dynamicFields,
  specialPro,
  handleEnrollId,
  handleSSN,
  handleSetName,
  handleSetEmail,
  handlePayment,
}) => {
  const { t } = useTranslation("enrollment");
  const {
    serviceAddress,
    promoCode,
    page_path,
    storePromoCode,
    handleSetErrorModalContent,
    utility,
    selectedProduct,
  } = useContext<any>(EnrollmentContext);
  const [inputValue, setInputValue] = useState<any>({
    first_name: { type: "text", value: "" },
    last_name: { type: "text", value: "" },
    email: { type: "text", value: "" },
    phone: { type: "number", value: "" },
    billing_address: { type: "text", value: "" },
    billing_address2: { type: "text", value: "" },
    billing_city: { type: "text", value: "" },
    billing_state: { type: "select", value: "" },
    billing_zipcode: { type: "text", value: "" },
    promo_code: { type: "text", value: promoCode },
    premise_type: { type: "text", value: "" },
    ext_source: { type: "text", value: page_path?.includes("/state/tx/save") && (promoCode === "EIQPPC") ? "v2" : "v1" },
    ext_source_path: { type: "text", value: page_path?.includes("/state/tx/save") && (promoCode === "EIQPPC") ? "/state/tx/save" : "/" },
    language: { type: "select", value: { label: "English", value: "english" } },
  });
  const [isSameBillingAddress, setIsSameBillingAddress] = useState(true);
  const [consentEmailMarketing, setConsentEmailMarketing] = useState(true);
  const [consentSmsMarketing, setConsentSmsMarketing] = useState(true);
  const [billingState, setBillingState] = useState<StatesOption | undefined>(
    undefined
  );
  const [reviewData, setReviewData] = useState<EnrollmentFields | undefined>(
    undefined
  );

  const { selectedPlan } = usePlanContext();
  // console.log({product})
  // console.log({selectedPlan})

  const [isAgree, setIsAgree] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorFields, setErrorFields] = useState<any>({});
  const [requiredFields, setRequiredFields] = useState<any>({
    last_name: { type: "text" },
    first_name: { type: "text" },
    email: { type: "email" },
    phone: { type: "number" },
    service_address: { type: "text" },
  });
  const [showSSN, setShowSSN] = useState(false);
  const promoCodeRef = useRef<null | HTMLDivElement>(null);
  const emailInputRef = useRef<null | HTMLDivElement>(null);
  const stepWrapperRef = useRef<HTMLDivElement>(null);

  const languageOptions = [
    { label: "English", value: "english" },
    { label: "Spanish", value: "spanish" },
  ];
  const [isAgreeCredit, setIsAgreeCredit] = useState(false);
  const [isAgreeLegal, setIsAgreeLegal] = useState(false);
  const [isAgreeDoc, setIsAgreeDoc] = useState(false);
  const [isAgreeContact, setIsAgreeContact] = useState(false);
  const [isAgreeInformational, setIsAgreeInformational] = useState(false);
  const [isAgreeRecord, setIsAgreeRecord] = useState(false);
  const [showConsentError, setShowConsentError] = useState<String[]>([]);
  const [serviceType, setServiceType] = useState<ServiceTypeOption | undefined>(
    undefined
  );
  const [startDate, setStartDate] = useState<undefined | Moment>(undefined);
  const [submitting, setSubmitting] = useState(false);
  const {
    holidays,
    getHolidays,
    // changeServiceAddress, changeUtility
  } = useContext<any>(EnrollmentContext);

  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const [recaptchaInstructionMessage, setRecaptchaInstructionMessage] = useState("");
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const recaptchaWrapperRef = useRef<HTMLDivElement>(null);
  const recaptchaScrollYRef = useRef(0);

  // Registration check state
  const [registrationStatus, setRegistrationStatus] = useState<RegistrationCheckStatus | null>(null);
  const [showRecaptcha, setShowRecaptcha] = useState(false);
  const [isRegistrationBlocked, setIsRegistrationBlocked] = useState(false);
  const [registrationBlockedMessage, setRegistrationBlockedMessage] = useState("");
  const [pendingEnrollment, setPendingEnrollment] = useState<{
    enrollmentId: string;
    specialPro: { ssn: any; date_of_birth: any };
    sign: string;
  } | null>(null);
  const recaptchaEnrollmentRef = useRef<{
    enrollmentId: string;
    specialPro: { ssn: any; date_of_birth: any };
    sign: string;
  } | null>(null);
  const awaitingRecaptchaSubmitRef = useRef(false);
  const submitInProgressRef = useRef(false);

  const BLOCK_DURATION_MS = 20 * 60 * 1000; // 20 minutes

  const getAddressKey = () => {
    if (!serviceAddress || serviceAddress.length === 0) return null;
    const { street, zipcode } = serviceAddress[0];
    return `reg_block_${street}_${zipcode}`.replace(/\s+/g, "_").toLowerCase();
  };

  const blockRegistrationForAddress = () => {
    const key = getAddressKey();
    if (!key) return;
    const blockData = { blockedAt: Date.now() };
    localStorage.setItem(key, JSON.stringify(blockData));
  };

  const checkAndUnblockIfExpired = () => {
    const key = getAddressKey();
    if (!key) return false;
    const stored = localStorage.getItem(key);
    if (!stored) return false;
    try {
      const { blockedAt } = JSON.parse(stored);
      const elapsed = Date.now() - blockedAt;
      if (elapsed >= BLOCK_DURATION_MS) {
        // Block has expired, clear it
        localStorage.removeItem(key);
        setIsRegistrationBlocked(false);
        setRegistrationBlockedMessage("");
        return false;
      }
      // Still blocked
      return true;
    } catch {
      localStorage.removeItem(key);
      return false;
    }
  };
  
  // Console log the utm parameters
  useEffect(() => {
    const utmParams = new URLSearchParams(window.location.search);
    const utmSource = utmParams.get("utm_source");
    const utmMedium = utmParams.get("utm_medium");
    const utmCampaign = utmParams.get("utm_campaign");
    console.log({ utmSource, utmMedium, utmCampaign });
  }, [window.location.search]);

  // Check for existing block on mount/show
  useEffect(() => {
    if (!show || !serviceAddress || serviceAddress.length === 0) return;
    const stillBlocked = checkAndUnblockIfExpired();
    if (stillBlocked) {
      setIsRegistrationBlocked(true);
      setRegistrationBlockedMessage("We are unable to register you due to multiple failed attempts. Please try again after 30 minutes.");
    }
    // Set up a timer to auto-unblock after remaining time
    const key = getAddressKey();
    if (!key) return;
    const stored = localStorage.getItem(key);
    if (!stored) return;
    try {
      const { blockedAt } = JSON.parse(stored);
      const remaining = BLOCK_DURATION_MS - (Date.now() - blockedAt);
      if (remaining > 0) {
        const timer = setTimeout(() => {
          localStorage.removeItem(key);
          setIsRegistrationBlocked(false);
          setRegistrationBlockedMessage("");
        }, remaining);
        return () => clearTimeout(timer);
      }
    } catch { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, serviceAddress]);

  useEffect(() => {
    setTimeout(() => {
      const promoCodeError = localStorage.getItem("promoCodeError");
      // console.log(promoCodeError)
      if (promoCodeError) {
        setErrorFields({
          promoCode: "Invalid Promo Code",
        });
        localStorage.removeItem("promoCodeError");
      }
    }, 500);
  }, [show]);
  useEffect(() => {
    if (!show) return;
    window.digitalData.page.pageInfo.pageName = "Funnel Step 2";
  }, [show]);
  useEffect(() => {
    if (dynamicFields) {
      let newInputValue = Object.assign({}, inputValue),
        newRequiredFields: any = Object.assign({}, requiredFields);

      for (let cate in dynamicFields) {
        for (let key in dynamicFields[cate]) {
          const item = dynamicFields[cate][key];
          const { type } = item;
          if (key === "ssn") {
            newInputValue[key] = { type: "number", value: "" };
          } else {
            if (type === "checkbox") {
              newInputValue[key] = { type: type, value: false };
            } else if (type === "date" || type === "select") {
              newInputValue[key] = { type: type, value: undefined };
            } else {
              newInputValue[key] = { type: type, value: "" };
            }
          }
          if (key !== "premise_type") {
            newRequiredFields[key] = { type: type };
          }
        }
      }
      setInputValue(newInputValue);
      setRequiredFields(newRequiredFields);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicFields]);
  const isStartDateFormatValid = (date: Moment | undefined) => {
    if (!date) return false;
    return (
      moment(date, "MM/DD/YYYY", true).isValid() ||
      moment(date, "M/DD/YYYY", true).isValid() ||
      moment(date, "MM/D/YYYY", true).isValid() ||
      moment(date, "M/D/YYYY", true).isValid()
    );
  };

  const getStepServiceErrors = (): Record<string, string> => {
    const errors: Record<string, string> = {};

    if (!serviceType) {
      errors.serviceType = t("This field is required");
      return errors;
    }

    if (serviceType.value !== "3" && !isStartDateFormatValid(startDate)) {
      errors.startDate = t("Invalid Date");
      return errors;
    }

    if (serviceType.value !== "3" && holidays && startDate) {
      if (
        startDate.isBefore(moment(holidays.start, "YYYY-MM-DD")) ||
        startDate.isAfter(moment(holidays.end, "YYYY-MM-DD"))
      ) {
        errors.startDate = t("Invalid Date");
        return errors;
      }

      const blackoutDate = holidays?.blackout_dates?.filter(
        (val: string) =>
          val.indexOf(moment(startDate).format("YYYY-MM-DD")) >= 0
      );
      if (blackoutDate.length > 0) {
        errors.startDate = t("Invalid Date");
      }
    }

    return errors;
  };

  const handleStepServiceSave = async () => {
    setLoading(true);

    let serviceTypeVal = "MoveIn",
      requestedDate = moment().add(1, "days").format("MM/DD/YYYY");
    if (serviceType && parseInt(serviceType.value) > 1) {
      serviceTypeVal = "Switching";
    }
    if (serviceType && parseInt(serviceType.value) < 3) {
      requestedDate = moment(startDate).format("MM/DD/YYYY");
    }
    const { esiid, street, zipcode, city, state } = serviceAddress[0];
    const saveFields = {
      esiid: esiid,
      service_address: street,
      service_zipcode: zipcode,
      service_city: city,
      service_state: state,
      service_type: serviceTypeVal,
      requested_date: requestedDate,
      // product: product,
      product: product || selectedPlan?.product,
    };
    return saveEnrollment(null, saveFields, null).then((res) => {
      setLoading(false);

      if (res && parseInt(res.status) === 1 && res.response) {
        const { enrollment_id } = res.response;
        const { sign } = res.response;
        if (enrollment_id) {
          handleEnrollId(enrollment_id, sign);
          return {
            enrollmentId: enrollment_id,
            sign: sign,
          };
        } else {
          handleSetErrorModalContent({
            title: "Enrollment Id does not exist",
          });
          // toast.error('Enrollment Id does not exist')
        }
      } else {
        handleSetErrorModalContent({
          title: getRegistrationErrorMessage(promoCode),
        });
        // toast.error(res.message)
      }
    });
  };
  const validate = () => {
    let isValid = true;
    let newErrorFields: any = {};

    for (let i in requiredFields) {
      const { type } = requiredFields[i];

      if (i === "service_address") {
        const _address = localStorage.getItem("selectedAddress");
        if (!_address) {
          newErrorFields[i] = t("This field is required");
          isValid = false;
        }
        continue;
      }
      if (type === "checkbox") {
        continue;
      } else if (type === "date") {
        if (
          !inputValue[i].value ||
          !handleDateValidation(inputValue[i].value)
        ) {
          newErrorFields[i] = t("Invalid Date");
          isValid = false;
        }
      } else if (type === "email") {
        // eslint-disable-next-line
        const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        if (!pattern.test(inputValue[i].value)) {
          newErrorFields[i] = t("Invalid emaill address format");
          isValid = false;
        }
      } else {
        if (!inputValue[i].value) {
          newErrorFields[i] = t("This field is required");
          isValid = false;
        }
      }
    }

    if (inputValue.phone.value.indexOf("_") >= 0) {
      newErrorFields["phone"] = t("Invalid Phone Number");
      isValid = false;
    }

    if (inputValue.ssn.value.indexOf("_") >= 0) {
      newErrorFields["ssn"] = t("Invalid SSN format");
      isValid = false;
    }

    if (!isSameBillingAddress && !billingState) {
      newErrorFields["billingState"] = t("This field is required");
      isValid = false;
    }

    if (!isAgree) {
      newErrorFields["isAgree"] = t("This field is required");
      isValid = false;
    }
    let newConsentError: String[] = [];
    if (!isAgreeRecord) {
      newConsentError.push("record");
      isValid = false;
    }

    const serviceErrors = getStepServiceErrors();
    if (Object.keys(serviceErrors).length > 0) {
      Object.assign(newErrorFields, serviceErrors);
      isValid = false;
    }

    setShowConsentError(newConsentError);
    setErrorFields(newErrorFields);
    if (!isValid) {
      scrollToFirstFormError(stepWrapperRef.current);
    }
    return isValid;
  };

  const scrollToRecaptchaIfNeeded = useCallback(() => {
    const el = recaptchaWrapperRef.current;
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const padding = 24;
    const inView =
      rect.top >= padding && rect.bottom <= window.innerHeight - padding;
    if (inView) return;

    el.scrollIntoView({ behavior: "auto", block: "center" });
  }, []);

  const submitWithRecaptchaToken = (token: string) => {
    const enrollmentContext =
      recaptchaEnrollmentRef.current ||
      pendingEnrollment ||
      (propEnrollmentId && propSign
        ? { enrollmentId: propEnrollmentId, sign: propSign, specialPro }
        : null);

    if (!enrollmentContext || submitInProgressRef.current) return;

    const { enrollmentId, specialPro: enrollSpecialPro, sign } = enrollmentContext;
    handleSubmit(enrollmentId, enrollSpecialPro, sign, token);
  };

  const handleSave = async () => {
    // Block submission if registration is not allowed (70.E03)
    if (isRegistrationBlocked) {
      handleSetErrorModalContent({
        title: getRegistrationErrorMessage(promoCode),
      });
      return;
    }

    // After reCAPTCHA is shown, only submit with the token — never save/retrieve again
    if (awaitingRecaptchaSubmitRef.current || showRecaptcha) {
      if (!recaptchaToken) {
        setRecaptchaInstructionMessage(
          "Please complete the reCAPTCHA verification before submitting."
        );
        scrollToRecaptchaIfNeeded();
        return;
      }
      submitWithRecaptchaToken(recaptchaToken);
      return;
    }

    if (loading || !validate()) return;

    setLoading(true);
    setSubmitting(true);
    let newErrorFields: any = {};

    let saveFields: any = {
      product: product,
    };

    const serviceAddr: any = {
      address: serviceAddress[0].street,
      state: serviceAddress[0].state,
      city: serviceAddress[0].city,
      zipcode: serviceAddress[0].zipcode,
    };

    let trueFields: any = {};
    const { enrollmentId, sign } = (await handleStepServiceSave()) || {
      enrollmentId: "",
      sign: "",
    };
    if (!enrollmentId) {
      setLoading(false);
      setSubmitting(false);
      return;
    }
    for (let i in inputValue) {
      if (i === "billing_address2") continue;

      const item = inputValue[i];
      if (i.indexOf("billing_") >= 0) {
        const _key = i.substr(8);
        if (i === "billing_address") {
          const billingAddress = `${item.value} ${inputValue.billing_address2.value}`;
          saveFields[i] = isSameBillingAddress
            ? serviceAddr[_key]
            : billingAddress.trim();
        } else {
          saveFields[i] = isSameBillingAddress
            ? serviceAddr[_key]
            : inputValue[`billing_${_key}`].value;
        }
      } else {
        if (item.type === "number") {
          saveFields[i] = item.value ? item.value.replace(/ /g, "") : "";
        } else if (item.type === "date") {
          saveFields[i] = moment(item.value).format("MM/DD/YYYY");
        } else if (item.type === "select") {
          saveFields[i] = item.value ? item.value.value : "";
        } else {
          saveFields[i] = item.value;
        }
      }
    }

    for (const key in saveFields) {
      if (key === "ssn" || key === "date_of_birth") {
        specialPro[key] = saveFields[key];
      } else {
        trueFields[key] = saveFields[key];
      }
    }

    trueFields["premise_type"] =
      serviceAddress[0].unit === "" ? "House" : "Apartment";
    trueFields["email_marketing_consent"] = consentEmailMarketing;
    trueFields["product"] = product;
    trueFields[SMS_MARKETING_CONSENT_FIELD] = isAgreeContact;
    trueFields[SMS_INFORMATIONAL_CONSENT_FIELD] = isAgreeInformational;
    const storedPagePath = localStorage.getItem("page_path");
    trueFields["ext_source"] = storedPagePath?.includes("/state/tx/save") && (promoCode === "EIQPPC") ? "v2" : "v1";
    trueFields["ext_source_path"] = storedPagePath?.includes("/state/tx/save") && (promoCode === "EIQPPC") ? "/state/tx/save" : "/";

    const utmParams = getUtmParams();
    const utmSource = utmParams.utm_source || "";
    const utmMedium = utmParams.utm_medium || "";
    const utmCampaign = utmParams.utm_campaign || "";
    if (utmSource) trueFields["utm_source"] = utmSource;
    if (utmMedium) trueFields["utm_medium"] = utmMedium;
    if (utmCampaign) trueFields["utm_campaign"] = utmCampaign;

    localStorage.removeItem("page_path"); // Clean up after use
    // trueFields['sms_marketing_consent'] = consentSmsMarketing;
    // storePromoCode(inputValue.promo_code.value);
    await pushEnrollmentEvent({
      event: "enrollment_credit_check",
      zip_code: utility.zipcode,
      user_region: serviceAddress[0].state,
      city: serviceAddress[0].city,
      provider:
        //@ts-ignore
        CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
        utility.utility_code,
      electricity_plan_rate: selectedProduct.price1000,
      electricity_plan_term: selectedProduct.contract_term,
      electricity_plan_name: selectedProduct.plan_name,
      electricity_plan_termination_fee: selectedProduct.cancel_fee,
      offer_code: localStorage.getItem("promoCode"),
      esiid: serviceAddress[0].esiid
    });

    const res = await saveEnrollment(enrollmentId, trueFields, sign);
    if (res && parseInt(res.status) === 1) {
      // Call retrieve to check registration_check status
      try {
        const retrieveRes = await getEnrollmentRecord(enrollmentId, sign);
        setLoading(false);

        const registrationCheck = retrieveRes?.response?.registration_check;

        if (registrationCheck) {
          const { status, message } = registrationCheck;
          setRegistrationStatus(status as RegistrationCheckStatus);

          switch (status) {
            case RegistrationCheckStatus.Passed:
              // 70.E01: No reCAPTCHA needed, proceed to submit
              handleSubmit(enrollmentId, specialPro, sign);
              break;
            case RegistrationCheckStatus.RecaptchaRequired:
              // 70.E02: Show reCAPTCHA inline, store pending enrollment
              recaptchaScrollYRef.current = window.scrollY;
              setRecaptchaInstructionMessage(
                "You have already attempted this before. Please complete the reCAPTCHA to continue"
              );
              setShowRecaptcha(true);
              setSubmitting(false);
              const recaptchaEnrollment = { enrollmentId, specialPro, sign };
              recaptchaEnrollmentRef.current = recaptchaEnrollment;
              awaitingRecaptchaSubmitRef.current = true;
              setPendingEnrollment(recaptchaEnrollment);
              break;
            case RegistrationCheckStatus.RegistrationBlocked:
              // 70.E03: Block registration
              setIsRegistrationBlocked(true);
              setSubmitting(false);
              setRegistrationBlockedMessage(message || "Registration is not allowed.");
              blockRegistrationForAddress();
              handleSetErrorModalContent({
                title: getRegistrationErrorMessage(promoCode),
              });
              break;
            default:
              // Unknown status, proceed normally
              handleSubmit(enrollmentId, specialPro, sign);
              break;
          }
        } else {
          // No registration_check in response, proceed normally
          handleSubmit(enrollmentId, specialPro, sign);
        }
      } catch {
        setLoading(false);
        // On retrieve error, proceed normally
        handleSubmit(enrollmentId, specialPro, sign);
      }
    } else {
      setLoading(false);
      setSubmitting(false);
      handleSetErrorModalContent({
        title: getRegistrationErrorMessage(promoCode),
      });
      // toast.error(res.message)
    }
  };
  const location = useLocation();
  const navigate = useNavigate();
  const hasCompletedContactInformation = useMemo(() => {
    const firstName = inputValue.first_name?.value;
    const lastName = inputValue.last_name?.value;
    const email = inputValue.email?.value as string | undefined;
    const phone = inputValue.phone?.value as string | undefined;

    return (
      Boolean(firstName) &&
      Boolean(lastName) &&
      hasProvidedEnrollmentEmail(email) &&
      hasProvidedEnrollmentPhone(phone)
    );
  }, [inputValue]);
  const [pushedToDL, setPushedToDL] = useState(false);
  const getEnrollmentConversionData = useCallback(
    () => ({
      email: inputValue.email?.value as string | undefined,
      phone: inputValue.phone?.value as string | undefined,
    }),
    [inputValue.email?.value, inputValue.phone?.value]
  );

  const pushEnrollmentEvent = useCallback(
    async (eventData: Record<string, unknown>) => {
      await pushEnrollmentEventToDataLayer(
        eventData,
        getEnrollmentConversionData()
      );
    },
    [getEnrollmentConversionData]
  );

  useEffect(() => {
    if (hasCompletedContactInformation && !pushedToDL) {
      setPushedToDL(true);
      void pushEnrollmentEvent({
        event: "enrollment_contact_information",
        provider:
          //@ts-ignore
          CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
          utility?.utility_code,
        electricity_plan_rate: selectedProduct.price1000,
        electricity_plan_term: selectedProduct.contract_term,
        electricity_plan_name: selectedProduct.plan_name,
        electricity_plan_termination_fee: selectedProduct.cancel_fee,
        offer_code: localStorage.getItem("promoCode"),
        referrer_url: `${REFERER_URL}${location.search}`,
      });
    }
  }, [hasCompletedContactInformation]);

  useEffect(() => {
    if (!showRecaptcha) return;

    const savedScrollY = recaptchaScrollYRef.current;

    const runScroll = () => {
      if (savedScrollY > 0 && window.scrollY === 0) {
        window.scrollTo(0, savedScrollY);
      }
      scrollToRecaptchaIfNeeded();
    };

    const timeoutId = window.setTimeout(() => {
      requestAnimationFrame(runScroll);
    }, 150);

    return () => clearTimeout(timeoutId);
  }, [showRecaptcha, scrollToRecaptchaIfNeeded]);

  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token);
    if (token) {
      setRecaptchaInstructionMessage("");
    }
  };

  const clearRecaptchaFlow = () => {
    awaitingRecaptchaSubmitRef.current = false;
    recaptchaEnrollmentRef.current = null;
    setPendingEnrollment(null);
    setShowRecaptcha(false);
    setRecaptchaToken(null);
    recaptchaRef.current?.reset();
  };

  const finishSubmitAttempt = (clearRecaptcha = false) => {
    submitInProgressRef.current = false;
    setSubmitting(false);
    if (clearRecaptcha) {
      clearRecaptchaFlow();
    }
  };

  const handleRecaptchaExpired = () => {
    setRecaptchaToken(null);
  };

  const handleSubmit = (
    enrollmentId: string,
    specialPro: { ssn: any; date_of_birth: any },
    sign: string,
    recaptchaTokenOverride?: string | null
  ) => {
    // Block submission if registration is not allowed (70.E03)
    if (isRegistrationBlocked) {
      handleSetErrorModalContent({
        title: getRegistrationErrorMessage(promoCode),
      });
      finishSubmitAttempt();
      return;
    }

    let newConsentError: String[] = [];
    if (!isAgreeRecord) newConsentError.push("record");

    setShowConsentError(newConsentError);
    if (newConsentError.length > 0) {
      finishSubmitAttempt();
      return;
    }
    if (submitInProgressRef.current) return;

    submitInProgressRef.current = true;
    setSubmitting(true);

    const tokenToSend =
      recaptchaTokenOverride ??
      (registrationStatus === RegistrationCheckStatus.RecaptchaRequired
        ? recaptchaToken
        : null);

    confirmEnrollment(
      enrollmentId,
      specialPro,
      sign,
      tokenToSend
    ).then(async (res) => {
      if (res) {
        if (res.error_code) {
          navigate(`/v2/enrollment/failed${location.search}`);
        }
        if (res.error_code && res.error_code === "500") {
          finishSubmitAttempt();
          handleSetErrorModalContent({
            title:
              res.message || t("The enrollment request has been submitted"),
          });
          // toast.error(res.message || t('The enrollment request has been submitted'))
          return;
        }
        const { status } = res;
        if (status) {
          const errorCode = status.split(".")[0];
          // let errorCode= "20"
          switch (errorCode) {
            case "-1":
              await pushEnrollmentEvent({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              finishSubmitAttempt();
              handleSetErrorModalContent({
                title: getRegistrationErrorMessage(promoCode),
              });
              break;
            case "0":
              await pushEnrollmentEvent({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              navigate(`/v2/enrollment/failed${location.search}`);
              finishSubmitAttempt(true);
              if (
                res.message &&
                (res.message.toLowerCase().indexOf("email_repeated") >= 0 ||
                  res.message.toLowerCase().indexOf("email_enrolled") >= 0)
              ) {
                handleSetErrorModalContent({
                  title: "Are you a current customer?",
                  desc: "It looks like you already have an account with us, please login to continue.",
                  button: "login",
                });
              } else {
                handleSetErrorModalContent({
                  title: getRegistrationErrorMessage(promoCode),
                });
              }
              // toast.error(t(res.message))
              if (res.message && res.message.indexOf("promoCode") >= 0) {
                handleBack();
                localStorage.setItem("promoCodeError", "1");
              }
              break;
            case "30":
              await pushEnrollmentEvent({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              navigate(`/v2/enrollment/failed${location.search}`);

              // } else {
              finishSubmitAttempt(true);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetName(
                `${reviewData
                  ? `${reviewData.first_name} ${reviewData.last_name}`
                  : ""
                }`
              );
              // }
              break;
            case "20":
              await pushEnrollmentEvent({
                event: "enrollment_deposit_required",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Deposit"
              });
              localStorage.setItem("enrollmentResult", JSON.stringify(res));
              handlePayment(res);
              finishSubmitAttempt(true);
              navigate(`/v2/enrollment/deposit${location.search}`);
              break;
            case "10":
              await pushEnrollmentOrderComplete(
                {
                  event: "enrollment_order_complete",
                  electricity_plan_name: selectedProduct.plan_name,
                  electricity_plan_rate: selectedProduct.price1000,
                  electricity_plan_term: selectedProduct.contract_term,
                  electricity_plan_termination_fee: selectedProduct.cancel_fee,
                  provider: //@ts-ignore
                    CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                    utility?.utility_code,
                  offer_code: localStorage.getItem("promoCode"),
                  city: serviceAddress[0].city,
                  user_region: serviceAddress[0].state,
                  zip_code: serviceAddress[0].zipcode,
                  confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                  esiid: serviceAddress[0].esiid,
                  status: "Accepted"
                },
                getEnrollmentConversionData()
              );
              finishSubmitAttempt(true);
              navigate(`/v2/enrollment/success${location.search}`);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetEmail(inputValue.email?.value || "");
              handleSetName(
                `${reviewData
                  ? `${reviewData.first_name} ${reviewData.last_name}`
                  : ""
                }`
              );
              break;
            case "40":
            case "50":
              await pushEnrollmentEvent({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                // Cancellation_fee: selectedProduct.cancel_fee,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              navigate(`/v2/enrollment/failed${location.search}`);
              finishSubmitAttempt(true);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetName(
                `${reviewData
                  ? `${reviewData.first_name} ${reviewData.last_name}`
                  : ""
                }`
              );
              break;
            case "70":
              // Registration blocked from submit response (70.E03)
              finishSubmitAttempt(true);
              setIsRegistrationBlocked(true);
              setRegistrationBlockedMessage(res.message || "Registration is not allowed.");
              blockRegistrationForAddress();
              handleSetErrorModalContent({
                title: getRegistrationErrorMessage(promoCode),
              });
              break;
            default:
          }
        }
      } else {
        await pushEnrollmentEvent({
          event: "enrollment_order_error",
          zip_code: serviceAddress[0].zipcode,
          user_region: serviceAddress[0].state,
          city: serviceAddress[0].city,
          provider:
            //@ts-ignore
            CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
            utility?.utility_code,
          electricity_plan_rate: selectedProduct.price1000,
          electricity_plan_term: selectedProduct.contract_term,
          electricity_plan_name: selectedProduct.plan_name,
          electricity_plan_termination_fee: selectedProduct.cancel_fee,
          offer_code: localStorage.getItem("promoCode"),
          confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
          esiid: serviceAddress[0].esiid,
          status: "Held/Rejected",
          error_message: res.message,
        });
        navigate(`/v2/enrollment/failed${location.search}`);
        finishSubmitAttempt();
        handleSetErrorModalContent({
          title: getRegistrationErrorMessage(promoCode),
        });
        // toast.error(t('An error occurred'))
      }
    });
  };

  const handleChangeInput = (evt: any) => {
    const { value, name } = evt.target;

    let newInputValue = Object.assign({}, inputValue);
    newInputValue[name as any].value = value;
    setInputValue(newInputValue);
  };

  const handleDateValidation = (inputDate: string) => {
    // Assuming inputDate is in MM/DD/YYYY format
    let parts = inputDate.split("/");
    let month = parseInt(parts[0], 10);
    let day = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);

    // Validate the date format and range
    if (
      !isNaN(month) &&
      !isNaN(day) &&
      !isNaN(year) &&
      month >= 1 &&
      month <= 12 &&
      day >= 1 &&
      day <= 31 &&
      year >= new Date().getFullYear() - 100 &&
      year <= new Date().getFullYear()
    ) {
      // Date is valid
      const { date_of_birth, ...errorField } = errorFields;
      setErrorFields(errorField);
      return true;
    } else {
      // Date is invalid
      setErrorFields((preProcessFiles: any) => ({
        ...preProcessFiles,
        date_of_birth: "Invalid date"
      }))
      return false;
    }
  };

  const getDynamicFields = (
    type: string,
    excludeKeys: string[] = [],
    includeKeys?: string[]
  ) => {
    const group = dynamicFields[type];

    return (
      <EnrollmentFormRow>
        {Object.keys(group).map((val, idx) => {
          if (includeKeys && !includeKeys.includes(val)) return null;
          if (excludeKeys.includes(val)) return null;
          const item = group[val];
          const { label, type } = item;
          if (type === "checkbox") {
            return (
              <EnrollmentFormCol key={idx}>
                <CheckboxItem
                  label={t(label)}
                  value={`${inputValue[val].value}`}
                  checked={inputValue[val].value}
                  handleClick={() => {
                    let newInputValue = Object.assign({}, inputValue);
                    newInputValue[val].value = !newInputValue[val].value;
                    setInputValue(newInputValue);
                  }}
                  onlyread={false}
                  disabled={loading}
                  id={label}
                />
              </EnrollmentFormCol>
            );
          } else if (type === "select") {
            if (val === "premise_type") return null;
            return (
              <EnrollmentFormCol key={idx}>
                <Form.Group className={errorFields[val] ? "error" : ""}>
                  <Form.Label>{t(label)} *</Form.Label>
                  <Dropdown className="plans-filter-dd">
                    <Dropdown.Toggle
                      disabled={loading}
                      variant="outline-secondary"
                    >
                      {inputValue[val] && inputValue[val].value
                        ? t(inputValue[val].value.label)
                        : `${t("Please Select")}...`}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {(item.value as Object[]).map(
                        (option: any, optionIdx) => {
                          return (
                            <Dropdown.Item
                              eventKey={option.label}
                              key={optionIdx}
                              onClick={() => {
                                let newInputValue = Object.assign(
                                  {},
                                  inputValue
                                );
                                newInputValue[val].value = option;
                                setInputValue(newInputValue);
                              }}
                              active={
                                inputValue[val].value &&
                                inputValue[val].value.value === option.value
                              }
                            >
                              {t(option.label)}
                            </Dropdown.Item>
                          );
                        }
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <FormError message={errorFields[val]} />
              </EnrollmentFormCol>
            );
          } else if (type === "date") {
            return (
              <EnrollmentFormCol key={idx}>
                <Form.Group className={errorFields[val] ? "error" : ""}>
                  <Form.Label>{t(label)} *</Form.Label>
                  <InputWithIcon>
                    <NumberFormat
                      format="##/##/####"
                      mask="_"
                      name="date"
                      value={inputValue[val] ? inputValue[val].value : undefined}
                      onChange={(e: any) => {
                        let date = e.target.value;
                        let newInputValue = Object.assign({}, inputValue);
                        newInputValue[val].value = date;
                        setInputValue(newInputValue);
                      }}
                      className="form-control"
                      disabled={loading}
                      onBlur={(e: any) => {
                        handleDateValidation(e.target.value);
                      }}
                    />
                    <svg
                      className="input-icon"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" stroke="#000" strokeWidth="2" />
                      <line x1="3" y1="10" x2="21" y2="10" stroke="#000" strokeWidth="2" />
                      <line x1="8" y1="2" x2="8" y2="6" stroke="#000" strokeWidth="2" strokeLinecap="round" />
                      <line x1="16" y1="2" x2="16" y2="6" stroke="#000" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </InputWithIcon>
                  {/* <Datetime
                                        value={inputValue[val] ? inputValue[val].value : undefined}
                                        onChange={(date: any) => {
                                            let newInputValue = Object.assign({}, inputValue)
                                            newInputValue[val].value = date
                                            setInputValue(newInputValue)
                                        }}
                                        initialViewDate={moment().subtract(30, 'years')}
                                        dateFormat="MM/DD/YYYY"
                                        timeFormat={false}
                                        closeOnSelect={true}
                                        isValidDate={(currentDate) => {
                                            if (currentDate.isAfter(moment())) return false
                                            return true
                                        }}
                                        inputProps={{
                                            placeholder: t('MM/DD/YYYY'),
                                            disabled: loading,
                                        }}
                                    /> */}
                </Form.Group>
                <FormError message={errorFields[val]} />
              </EnrollmentFormCol>
            );
          } else {
            if (val === "ssn" && inputValue[val]) {
              return (
                <EnrollmentFormCol key={idx}>
                  <InputWithMask>
                    <Form.Group className={errorFields[val] ? "error" : ""}>
                      <Form.Label>{t("SSN")} *</Form.Label>
                      <NumberFormat
                        format="### ## ####"
                        mask="_"
                        name={val}
                        value={inputValue[val].value}
                        onChange={handleChangeInput}
                        className="form-control"
                        disabled={loading}
                      />
                      {!showSSN && (
                        <NumberFormat
                          type="password"
                          maxLength={9}
                          name={val}
                          value={inputValue[val].value}
                          onChange={handleChangeInput}
                          className="form-control mask-input"
                          disabled={loading}
                        />
                      )}
                    </Form.Group>
                    <InputMaskToggle
                      type="button"
                      active={showSSN}
                      onClick={() => setShowSSN(!showSSN)}
                    />
                  </InputWithMask>
                  <FormError message={errorFields[val]} />
                </EnrollmentFormCol>
              );
            }
            return (
              <EnrollmentFormCol key={"stepInfo"}>
                <Form.Group className={errorFields[val] ? "error" : ""}>
                  <Form.Label>{t(label)} *</Form.Label>
                  <Form.Control
                    type="text"
                    name={val}
                    placeholder=""
                    maxLength={50}
                    value={inputValue[val] ? inputValue[val].value : undefined}
                    onChange={handleChangeInput}
                    disabled={loading}
                  />
                </Form.Group>
                <FormError message={errorFields[val]} />
              </EnrollmentFormCol>
            );
          }
        })}
      </EnrollmentFormRow>
    );
  };

  if (!show) return null;
  if (!dynamicFields) {
    return (
      <div className="d-flex justify-content-center pt-5 pb-5">
        <LoadingRow />
      </div>
    );
  }

  return (

    <EnrollmentStepWrapper ref={stepWrapperRef}>
      {/* show this title on desktop and but not on mobile, tab */}
      <EnrollmentTitle className="d-none d-lg-block mt-5">
        Complete your enrollment
      </EnrollmentTitle>

      <EnrollmentStepService
        billingState={billingState}
        handleChangeInput={handleChangeInput}
        inputValue={inputValue}
        isSameBillingAddress={isSameBillingAddress}
        requiredFields={requiredFields}
        setBillingState={setBillingState}
        setInputValue={setInputValue}
        setIsSameBillingAddress={setIsSameBillingAddress}
        setRequiredFields={setRequiredFields}
        show={show}
        startDate={startDate}
        serviceType={serviceType}
        setServiceType={setServiceType}
        setStartDate={setStartDate}
        errorFields={errorFields}
      />
{/* h6 font size 16px  in mobile  it should be 14px*/}
      <h6 className="mt-2 fs-14-mobile">Personal information *</h6>
      {serviceAddress && <h5 className="mt-2">{serviceAddress[0]?.label}</h5>}
      <Form style={{ position: "relative" }}>
        <EnrollmentFormRow>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["first_name"] ? "error" : ""}>
              <Form.Label>{t("First Name")} *</Form.Label>
              <Form.Control
                type="text"
                name="first_name"
                maxLength={50}
                value={inputValue.first_name.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["first_name"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["last_name"] ? "error" : ""}>
              <Form.Label>{t("Last Name")} *</Form.Label>
              <Form.Control
                type="text"
                name="last_name"
                maxLength={50}
                value={inputValue.last_name.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["last_name"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["email"] ? "error" : ""}>
              <Form.Label>{t("Email")} *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder=""
                maxLength={150}
                value={inputValue.email.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["email"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["phone"] ? "error" : ""}>
              <Form.Label>{t("Phone Number")} *</Form.Label>
              <NumberFormat
                format="### ### ####"
                mask="_"
                name="phone"
                value={inputValue.phone.value}
                onChange={handleChangeInput}
                className="form-control"
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["phone"]} />
          </EnrollmentFormCol>
        </EnrollmentFormRow>


        {getDynamicFields("ext_input", ["date_of_birth"])}
        <div className="gap-2">

          <CreditCheckSection>
            <h5>{t("Utility Credit Check")}</h5>
            <p>
              {t(
                "A utility soft credit check is necessary to assess whether a deposit will be required. lt does not affect your credit score. Your information is securely transmitted over an encrypted connection to Constellation Energy, a Texas Retail Energy Provider, which requirespersonal identification information to review and process your enrollment. Constellation.com does not store, use, or sell any personal information collected."
              )}
            </p>
            <div className="d-md-flex  align-items-center justify-content-between">
              <div className="w-100">
                <div className=" w-100 d-flex align-items-center justify-content-between">
                  <div className="w-100">
                    {getDynamicFields("credit_check")}
                  </div>

                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="flex-fill">
                    {getDynamicFields("ext_input", [], ["date_of_birth"])}
                  </div>
                </div>
              </div>
              <div>
                <FooterAwardImage src="/images/constenewImg/top-providers-2025-min.png" alt="texas" />
              </div>
            </div>

          </CreditCheckSection>
          <EnrollmentFormRow>
            <EnrollmentFormCol full>
              <div
                className="checkbox-row"
                style={{ display: "flex", alignItems: "center" }}
              >
                <CheckboxItem
                  label=""
                  value={`${isAgree}`}
                  checked={isAgree}
                  handleClick={() => {
                    setIsAgree(!isAgree);
                  }}
                  onlyread={false}
                  disabled={loading}
                  id="is-agree-tos"
                  error={errorFields["isAgree"]}
                  renderLabel={() => (
                    <>
                      <span>
                        {t(
                          "I hereby authorize Constellation.com to run a credit check and perform all necessary tasks to establish electricity service. I accept the terms and conditions of the Constellation.com."
                        )}
                      </span>
                    </>
                  )}
                />
                {/* <FormError message={errorFields["isAgree"]} /> */}
              </div>
            </EnrollmentFormCol>
          </EnrollmentFormRow>
          <EnrollmentFormRow>
            <EnrollmentFormCol full>
              <div className="checkbox-row">
                <p style={{ fontSize: "1.1rem" }}>
                  Check the box(es) on the left to agree to the terms below:
                </p>
                <CheckboxItem
                  // eslint-disable-next-line react/jsx-key
                  label=""
                  value={`${isAgreeRecord}`}
                  checked={isAgreeRecord}
                  handleClick={() => {
                    let [...newShowConsentError] = showConsentError;
                    const pos = showConsentError.indexOf("record");
                    if (pos >= 0) {
                      newShowConsentError.splice(pos, 1);
                      setShowConsentError(newShowConsentError);
                    }
                    setIsAgreeRecord(!isAgreeRecord);
                  }}
                  onlyread={false}
                  disabled={loading}
                  error={showConsentError.indexOf("record") >= 0}
                  renderLabel={() => (
                    <>
                      <span>
                        I consent to the use of electronic records and
                        signatures including the provision of state and
                        federal disclosures in place of written
                        documentation and handwritten signatures in
                        connection with my enrollment application.
                      </span>
                      <span style={{ marginTop: "20px" }}>
                        I authorize Constellation to share my customer
                        information with its affiliates and its and their
                        third party providers, provided that each such
                        recipient agrees to hold such information in
                        confidence.
                      </span>
                      <span style={{ marginTop: "20px" }}>
                        I agree on behalf of myself, the applicant, that I
                        am demonstrating the ability to access and view all
                        enrollment information in the electronic formats
                        disclosed above and agree to print and keep a copy
                        of this enrollment for my records.
                      </span>
                    </>
                  )}
                />
              </div>
              <SmsConsentAgreements
                informationalChecked={isAgreeInformational}
                marketingChecked={isAgreeContact}
                onToggleInformational={() =>
                  setIsAgreeInformational(!isAgreeInformational)
                }
                onToggleMarketing={() => setIsAgreeContact(!isAgreeContact)}
                disabled={loading}
              />
            </EnrollmentFormCol>
          </EnrollmentFormRow>
          {showRecaptcha && !isRegistrationBlocked && (
            <div ref={recaptchaWrapperRef} style={{ margin: "20px 0" }}>
              {recaptchaInstructionMessage && (
                <p style={{ color: "red", marginBottom: "8px", fontSize: "0.9rem" }}>
                  {recaptchaInstructionMessage}
                </p>
              )}
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleRecaptchaChange}
                onExpired={handleRecaptchaExpired}
              />
            </div>
          )}
          <EnrollmentStepFooter>
            <Button
              secondary
              disabled={loading}
              type="button"
              onClick={() => handleBack()}
            >
              {t("Back")}
            </Button>
            <Button
              type="button"
              onClick={() => handleSave()}
              data-test-id="cta"
              disabled={loading || isRegistrationBlocked || submitting}
            >
              <span>{t("Submit")}</span>
              {loading && (
                <Spinner
                  animation="border"
                  variant="light"
                  size="sm"
                  className="ms-2"
                />
              )}
            </Button>
          </EnrollmentStepFooter>{" "}
        </div>

        <FormLoading
          show={submitting}
          content={t("This process may take up to 1 minute", { ns: "common" })}
        />
      </Form>
    </EnrollmentStepWrapper>
  );
};
